import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#0F1117', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', textAlign: 'center', padding: 24 }}>
      <div style={{ color: '#00D4AA', fontSize: 80, fontWeight: 800, lineHeight: 1 }}>404</div>
      <h1 style={{ color: '#E8ECF4', fontSize: 24, fontWeight: 700, marginTop: 16, marginBottom: 8 }}>페이지를 찾을 수 없습니다</h1>
      <p style={{ color: '#8892A4', fontSize: 14, marginBottom: 32 }}>요청하신 페이지가 존재하지 않거나 이동되었습니다.</p>
      <div style={{ display: 'flex', gap: 12 }}>
        <button onClick={() => navigate(-1)}
          style={{ background: 'none', border: '1px solid #2A3045', borderRadius: 8, padding: '10px 24px', color: '#8892A4', fontSize: 14, cursor: 'pointer' }}>
          ← 이전 페이지
        </button>
        <button onClick={() => navigate('/')}
          style={{ background: '#00D4AA', border: 'none', borderRadius: 8, padding: '10px 24px', color: '#0A1F18', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
          홈으로 가기
        </button>
      </div>
    </div>
  );
}
